import React, { useCallback } from "react";
import { Facet } from "@linkfluence/models/facet";
import Checkbox from "@ui-kit/form/checkbox";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { getTermFromCard } from "@radarly/models/cards/term";
import { DatavizMap, updateDatavizOptions } from "@radarly/models/dataviz";

export interface SharedPanelsCardEditionSidebarOptionsMapProps {
  dataviz: DatavizMap;
  setDataviz: (dataviz: DatavizMap) => void;
  card: Card;
  color: React.ReactElement;
}

export default function SharedPanelsCardEditionSidebarOptionsMap({
  dataviz,
  setDataviz,
  card,
  color,
}: SharedPanelsCardEditionSidebarOptionsMapProps) {
  const locale = useCurrentUserLocale();

  const updatePopulations = useCallback(() => {
    const value = dataviz.populations ? false : true;
    setDataviz(
      updateDatavizOptions(
        dataviz,
        "populations",
        value as DatavizMap["populations"]
      )
    );
  }, [dataviz, setDataviz]);

  const term = getTermFromCard(card);

  return (
    <>
      {term === Facet.Countries && (
        <Checkbox
          label={tr(
            locale,
            "CUSTOM_PAGES::EDITOR::DATAVIZ::MAP_VALUES_POPULATION"
          )}
          checked={dataviz.populations || undefined}
          onClick={updatePopulations}
        />
      )}
      {color}
    </>
  );
}
